module.exports = __webpack_public_path__ + "static/media/moment.1de9a17e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/types/moment.jpg
// module id = 74
// module chunks = 0